<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <Field
      v-slot="{ field }"
      v-model="optionalInformation.native_language_id"
      name="native_language_id"
    >
      <div class="input-group row pe-0">
        <div class="d-flex pe-0 justify-content-between mb-1">
          <label class="size-12" for="">母国語</label>
        </div>
        <div class="col-12 col-md-4 pe-0">
          <select class="form-select select-input-primary size-14 p-0d8" v-bind="field">
            <option value="" disabled selected></option>
            <option v-for="language in languages" :key="language.id" :value="language.id">
              {{ language.name }}
            </option>
          </select>
        </div>
      </div>
    </Field>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { Field } from 'vee-validate';
import { LanguageType } from '@/types/models/LanguageType';
import { getMasterLanguage } from '@/apis/candidate';
import { useOptionalInformationStore } from '@/stores/resume-candidate/OptionalInformation.store';

const languages = ref<LanguageType[]>([]);
const optionalInformation = useOptionalInformationStore();

onMounted(() => {
  loadLanguages();
});

const loadLanguages = async (): Promise<void> => {
  const res = await getMasterLanguage();
  if (res.status === 200) {
    languages.value = res.data;
  }
};
</script>
